var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            data: _vm.list.value,
            "span-method": _vm.arraySpanMethod,
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "pluginCode", label: "插件ID" },
          }),
          _c("el-table-column", { attrs: { prop: "name", label: "策略名称" } }),
          _c("el-table-column", {
            attrs: { prop: "priority", label: "优先级" },
          }),
          _c("el-table-column", {
            attrs: { prop: "createUser", label: "上传人/时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.appPlugin.createUser)),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(scope.row.appPlugin.createTime)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "updateUser", label: "更新人/时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.updateUser))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(scope.row.updateTime))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 0
                      ? _c("span", [_vm._v("起草中")])
                      : _vm._e(),
                    scope.row.status === 1
                      ? _c("span", [_vm._v("已上架")])
                      : _vm._e(),
                    scope.row.status === 2
                      ? _c("span", [_vm._v("已下架")])
                      : _vm._e(),
                    scope.row.status === 3
                      ? _c("span", [_vm._v("已禁用")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PLUGIN_MANAGE_PLUGIN_TACTICS_EDIT",
                            expression: "'PLUGIN_MANAGE_PLUGIN_TACTICS_EDIT'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.edit(scope.row)
                          },
                        },
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PLUGIN_MANAGE_PLUGIN_TACTICS_PUT_ON",
                            expression: "'PLUGIN_MANAGE_PLUGIN_TACTICS_PUT_ON'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.putOn(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("发布")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PLUGIN_MANAGE_PLUGIN_TACTICS_PUT_OFF",
                            expression:
                              "'PLUGIN_MANAGE_PLUGIN_TACTICS_PUT_OFF'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.putOff(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("下架")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PLUGIN_MANAGE_PLUGIN_TACTICS_DISABLE",
                            expression:
                              "'PLUGIN_MANAGE_PLUGIN_TACTICS_DISABLE'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.disable(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("禁用")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PLUGIN_MANAGE_PLUGIN_TACTICS_DEL",
                            expression: "'PLUGIN_MANAGE_PLUGIN_TACTICS_DEL'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.del(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          total: _vm.searchParams.total,
          current: _vm.searchParams.current,
          size: _vm.searchParams.size,
          pageSizes: [10, 20, 100],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("Add", { ref: "addDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }